<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <base-input label="Select Labor">
          <el-select
            v-model="selectedLabor"
            clearable
            filterable
            style="width: 100%"
            value-key="laborCostId"
            @change="addServiceRequestLabors"
          >
            <el-option
              v-for="(item, index) in laborCosts"
              :key="index"
              :value="item"
              :label="`${item.description} (${item.cost})`"
            />
          </el-select>
        </base-input>
      </div>
      <div class="col-md-6 offset-md-2">
        <div style="float: right">
          <base-button
            v-if="serviceRequest.vendorInvoice"
            style="margin-right: 10px"
            type="success"
            effect="dark"
            @click="getVendorInvoiceProducts()"
            >Vendor's Invoice Generated</base-button
          >
          <base-button
            v-else
            size="sm"
            type="primary"
            effect="dark"
            @click="getVendorInvoiceProducts()"
            >Generate Vendor's Invoice</base-button
          >
          <base-button
            v-if="serviceRequest.saleId"
            type="success"
            effect="dark"
            @click="getSaleInvoiceProducts()"
            >Invoice Generated</base-button
          >
          <base-button
            v-else
            size="sm"
            type="primary"
            @click="getSaleInvoiceProducts()"
            >Generate Sale</base-button
          >
        </div>
      </div>
    </div>
    <div class="row service-request-labors">
      <el-table
        v-if="serviceRequestLabors.length > 0"
        :data="serviceRequestLabors"
      >
        <el-table-column label="Desc.">
          <template slot-scope="scope">{{ scope.row.description }}</template>
        </el-table-column>
        <el-table-column label="Cost">
          <template slot-scope="scope">
            <base-input
              v-if="
                scope.row.isLaborEditable && scope.row.isLaborEditable === true
              "
              v-model="scope.row.laborCost"
            />
            <span v-else>
              {{ scope.row.laborCost }}
            </span>

            <base-button
              v-if="scope.row.isLaborEditable"
              size="sm"
              @click="updateLaborCost(scope.row)"
              >Update</base-button
            >
            <base-button
              v-else-if="!serviceRequest.vendorInvoice"
              size="sm"
              @click="scope.row.isLaborEditable = true"
              >Edit</base-button
            >
          </template>
        </el-table-column>
        <el-table-column label="Qty" min-width="150">
          <template slot-scope="scope">
            <el-input-number
              v-model="scope.row.quantity"
              :min="1"
              @change="updateQuantity(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="Disc">
          <template slot-scope="scope">{{ scope.row.discount }}</template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">{{
            calculateTotal(scope.row)
          }}</template>
        </el-table-column>
        <el-table-column label="Action">
          <template slot-scope="scope">
            <base-button
              v-if="!serviceRequest.vendorInvoice"
              size="sm"
              @click="deleteLabor(scope.row)"
              >Delete</base-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="showVendorInvoiceData" title="Vendor Invoice">
      <el-table
        :data="vendorInvoiceData.labors"
        :show-summary="true"
        :summary-method="getTotalOfVendorInvoice"
        height="350"
      >
        <el-table-column label="Name">
          <template slot-scope="scope">
            <div>{{ scope.row.description }}</div>
            <div>Qty: {{ scope.row.quantity }}</div>
            <div>Disc: {{ scope.row.discount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Price">
          <template slot-scope="scope">
            {{ scope.row.laborCost | currency }}
          </template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">
            {{ scope.row.total | currency }}
          </template>
        </el-table-column>
        <template slot="append">
          <tr>
            <td>
              External Goods Total:
              {{ vendorInvoiceData.externalGoodsTotal | currency }}
            </td>
          </tr>
        </template>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!serviceRequest.vendorInvoice"
          type="primary"
          @click="generateVendorsInvoice()"
        >
          Generate Vendor's Invoice
        </el-button>
      </span>
    </el-dialog>
    <!-- sale invoice data -->
    <el-dialog
      :visible.sync="showSaleInvoiceProducts"
      title="Sale Invoice Products"
      width="80%"
    >
      <el-table
        :data="saleInvoiceProducts"
        :show-summary="true"
        :summary-method="getSummary"
        sum-text="Total"
        height="350"
      >
        <el-table-column label="Name">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
            <div>Qty: {{ scope.row.quantity }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Qty">
          <template slot-scope="scope">
            {{ scope.row.quantity }}
          </template>
        </el-table-column>
        <el-table-column label="Price">
          <template slot-scope="scope">
            {{ scope.row.price }}
          </template>
        </el-table-column>
        <el-table-column label="Disc.">
          <template slot-scope="scope">
            <span v-if="scope.row.isPercentage === true"
              >{{ scope.row.discount }}%</span
            >
            <span v-else>{{ scope.row.discount | currency }} </span>
          </template>
        </el-table-column>
        <el-table-column label="Tax Rate">
          <template slot-scope="scope"> {{ scope.row.taxRate }}% </template>
        </el-table-column>
        <el-table-column label="Total">
          <template slot-scope="scope">
            {{ scope.row.total | currency }}
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!serviceRequest.saleId"
          type="primary"
          @click="generateSale()"
        >
          Generate Invoice
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import {
  Select,
  Option,
  Table,
  TableColumn,
  InputNumber,
  Tag,
  Dialog,
  Button
} from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [InputNumber.name]: InputNumber,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    [Button.name]: Button
  },
  filters: {
    currency(value) {
      const amount = parseFloat(value) || 0;
      const a = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(amount);
      return a.replace(".00", "");
    }
  },
  data: () => {
    return {
      selectedLabor: {},
      vendorInvoiceData: {},
      showVendorInvoiceData: false,
      saleInvoiceProducts: [],
      showSaleInvoiceProducts: false
    };
  },
  computed: {
    ...mapState("laborCost", ["laborCosts"]),
    ...mapState("serviceRequest", ["serviceRequest"]),
    ...mapState("serviceRequestChalan", [
      "serviceRequestChalan",
      "serviceRequestChalansList"
    ]),
    ...mapState("serviceRequestLabor", [
      "serviceRequestLabors",
      "serviceRequestLabor"
    ]),
    ...mapGetters({
      statusList: "status/getStatusList",
      serviceRequestTransactions:
        "serviceRequestTransaction/getServiceRequestTransactions"
    })
  },
  mounted() {
    this.getLaborCosts();
    this.getServiceRequestLabors(this.$route.params.id);
  },
  methods: {
    ...mapActions({
      getLaborCosts: "laborCost/getLaborCosts",
      getServiceRequestLabors: "serviceRequestLabor/getServiceRequestLabors",
      saveServiceRequestLabor: "serviceRequestLabor/saveServiceRequestLabor",
      updateLabor: "serviceRequestLabor/updateServiceRequestLabor",
      generateServiceRequestSale: "serviceRequest/generateSale",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      generateVendorsInvoiceNumber:
        "serviceRequest/generateVendorsInvoiceNumber",
      deleteServiceRequestLabor:
        "serviceRequestLabor/deleteServiceRequestLabor",
      getVendorInvoiceData: "serviceRequest/getVendorInvoiceData",
      fetchSaleInvoiceProducts: "serviceRequest/getSaleInvoiceProducts"
    }),
    ...mapMutations({
      setServiceRequestLabor: "serviceRequestLabor/setServiceRequestLabor"
    }),
    addServiceRequestLabors(item) {
      if (
        this.serviceRequest.vendorInvoice ||
        this.serviceRequest.status.code === "completed"
      ) {
        this.$notify({
          message:
            "Sorry, you cannot add labor after generating invoice or with completed status!",
          type: "danger",
          title: "Failure"
        });
      } else {
        this.addNewLabor(item);
      }
    },
    addNewLabor(item) {
      this.setServiceRequestLabor({
        quantity: 1,
        laborCost: item.cost,
        serviceRequestId: this.$route.params.id,
        description: item.description,
        vendorId: this.serviceRequest.vendorId
      });
      if (item.cost) {
        this.saveServiceRequestLabor()
          .then(res => {
            if (res.status === 201) {
              this.selectedLabor = {};
              this.$notify({
                message: "Labor Added Successfully!",
                type: "success",
                title: "Success"
              });
            }
            this.getServiceRequestLabors(this.$route.params.id);
          })
          .catch(() => {
            this.$notify({
              message: "Try Again!",
              type: "danger",
              title: "Failure"
            });
          });
      } else {
        this.$notify({
          message: "Cost Not Added!",
          type: "danger",
          title: "Failure"
        });
      }
    },

    editLaborPrice(item) {
      item.isLaborEditable = true;
    },
    async updateQuantity(item) {
      await this.updateLabor({
        quantity: item.quantity,
        serviceRequestId: this.$route.params.id,
        serviceRequestLaborId: item.serviceRequestLaborId
      }).then(() => {
        this.$notify({
          message: "Quantity Updated Successfully!",
          type: "success",
          title: "Success"
        });
      });
    },

    updateLaborCost(item) {
      this.updateLabor({
        laborCost: item.laborCost,
        serviceRequestId: this.$route.params.id,
        serviceRequestLaborId: item.serviceRequestLaborId
      }).then(() => {
        this.getServiceRequestLabors(this.$route.params.id);
        this.$notify({
          message: "Quantity Updated Successfully!",
          type: "success",
          title: "Success"
        });
      });
    },
    calculateTotal(item) {
      return item.laborCost * item.quantity - item.discount;
    },
    /* sale invoice methods*/
    async getSaleInvoiceProducts() {
      const status = this.serviceRequestChalansList.find(
        i => i.status.label === "Pending" || i.status.label === "Dispatched"
      );
      if (
        this.serviceRequestChalansList &&
        this.serviceRequestChalansList.length <= 0
      ) {
        this.$notify({
          message: "No Chalan Added!",
          type: "warning",
          title: "Warning"
        });
      } else if (status) {
        this.$notify({
          message:
            "Chalans are Pending Or Dispatched, So sale Cant Be Generate!",
          type: "warning",
          title: "Warning"
        });
      } else {
        this.saleInvoiceProducts = await this.fetchSaleInvoiceProducts(
          this.serviceRequest.serviceRequestId
        );
        this.showSaleInvoiceProducts = true;
      }
    },
    getSummary(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 5) {
          const sum = data.reduce((a, b) => {
            return a + b.total;
          }, 0);
          sums[index] = "Rs. " + sum;
        }
      });
      return sums;
    },
    generateSale() {
      this.generateServiceRequestSale(this.$route.params.id).then(() => {
        this.$notify({
          message: "Sale Generated Successfully!",
          type: "success",
          title: "Success"
        });
        this.showSaleInvoiceProducts = false;
      });
    },
    /*vendor invoice*/

    async getVendorInvoiceProducts() {
      this.vendorInvoiceData = await this.getVendorInvoiceData(
        this.serviceRequest.serviceRequestId
      );
      this.showVendorInvoiceData = true;
    },
    getTotalOfVendorInvoice(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        if (index === 2) {
          let sum = data.reduce((a, b) => {
            return a + b.total;
          }, 0);
          sum += this.vendorInvoiceData.externalGoodsTotal;
          sums[index] = "Rs. " + sum;
        }
      });
      return sums;
    },

    generateVendorsInvoice() {
      if (
        this.serviceRequest.externalGoodMeta != {} ||
        this.serviceRequestLabors.length > 0
      ) {
        this.generateVendorsInvoiceNumber().then(res => {
          if (res) {
            this.$notify({
              message: "Vendor Invoice Generated Successfully!",
              type: "success",
              title: "Success"
            });
            this.showVendorInvoiceData = false;
          }
        });
      } else {
        this.$notify({
          message:
            "No External Good/s or Labor Added, So Vendor's Invoice Can't Be Generate!",
          type: "warning",
          title: "Warning"
        });
      }
    },
    deleteLabor(item) {
      this.deleteServiceRequestLabor({
        serviceRequestId: item.serviceRequestId,
        serviceRequestLaborId: item.serviceRequestLaborId
      }).then(res => {
        if (res.status === 201) {
          this.getServiceRequestLabors(this.$route.params.id);

          this.$notify({
            message: "Labor Deleted Successfully!",
            type: "success",
            title: "Success"
          });
        } else {
          this.$notify({
            message: "Error Occurred!",
            type: "failure",
            title: "Error"
          });
        }
      });
    }
  }
};
</script>

<style>
.service-request-labors {
  margin-top: 20px;
  margin-bottom: 90px;
}
</style>
